import { I18N } from 'aurelia-i18n';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { TransactionBalancePaymentType } from '../../../../models/enums/transaction-balance-payment-type';
import { PaymentItemTableConfiguration } from '../../../../models/payment-item-table-configuration';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class VerifyShortPayReasonCommentRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[], private paymentConfiguration: PaymentItemTableConfiguration) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		// enforce customer account minimum payment due if necessary
		try {
			let isValid: boolean = true;
			this.items.forEach((i: AccountPaymentItem) => {

				if (((parseInt(i.enteredAmount, 10) || 0) < i.initialAmount)
					&& !this.paymentConfiguration.isPayInFull) {
					i.paymentBalanceType = TransactionBalancePaymentType.ShortPayment;
				}

				if (isValid &&
					i.isSelected &&
					i.paymentLimitSettings.requireShortPayReason &&
					i.paymentBalanceType === TransactionBalancePaymentType.ShortPayment &&
					i.paymentLimitSettings.enableShortPayUserComment &&
					i.paymentLimitSettings.selectedShortPayReason === -1 &&
					i.paymentLimitSettings.shortPayComment.trim() === '' &&
					!this.paymentConfiguration.isPayInFull) {
					isValid = false;
				}
			});

			result.isValid = isValid;
		}
		catch (err) {
			result.isValid = false;
		}

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('shortPaymentCommentRequired',
				'Short pay comment required when selecting "Other" as a reason.');
		}

		return result;
	}
}
